import React, {useState, useEffect} from 'react';
import propTypes from 'prop-types';
import {get} from 'lodash';
import styled from '@emotion/styled';
import {TextField} from '@mui/material';
import {Controller} from "react-hook-form";
import isPostalCode from 'validator/lib/isPostalCode';
import {theme} from '../../../../themes/default-theme';
import Dropdown from '../../../../components/ui/Dropdown';
import getClosestDealer from '../../../../util/getClosestDealer';
import getClosestDealersByPostcode from '../../../../util/getClosestDealersByPostcode';

const FormItem = styled.div`
  display: block;
  margin:${props => props.margin === 'none' ? `0` : `30px 0`};
  width: 100%;
  text-align: left;

  ${props => props.display === 0 && `
    display: none;
  `}
`

const FormCol = styled.div`

  ${theme.breakpoints.down('sm')} {
    ${props => props.position === 'left' && `
      margin-bottom: 30px;
    }`
  }

  ${theme.breakpoints.up('md')} {
    ${props => props.position === 'left' ? `
      padding-right: 15px;
    ` : `
      padding-left: 15px;
    `}
  }
`

const Error = styled.p`
  color: ${theme.palette.error.form}
`

const step2DefaultPropSetDealerSummary = () => {};

const Step2 = ({formProps, countryCode = 'AU', state, dealers, onFormChange, dealersSelect, setDealersSelect, setDefaultDealer, setDealerSummary = step2DefaultPropSetDealerSummary, motorhomeCapvervans}) => {

  const {
    control,
    errors
  } = formProps

  const textFieldProps = {
    as:TextField,
    control:control,
    rules:{required: true },
    variant:"outlined",
    fullWidth: true,
    defaultValue: ''
  }

  const [closestDealersState, setClosestDealers] = useState([])

  useEffect(() => {
    if (state.postcode && state.postcode.length === 4) {
      getDealerFromPostcode(state.postcode);
    }
  }, [state.postcode])

  const getDealerFromPostcode = (postcode) => {

     // Start temp update of hardcoded postcodes before Jayco
    const coffsHarbourPostcodes = ['2408', '2409', '2410', '2411', '2475', '2476', '2481', '2482', '2484', '2474', '2480', '2477', '2479', '2372']

    const isCoffsHarbourPostcode = coffsHarbourPostcodes.indexOf(postcode.toString()) !== -1;

    if (isCoffsHarbourPostcode && motorhomeCapvervans) {

      const _dealers = dealers.filter(item => item.title.toLowerCase() === 'watsons coffs harbour')

      console.log('getDealerFromPostcode', {postcode, coffsHarbourPostcodes, _dealers, isCoffsHarbourPostcode}); 
      
      setDealersSelect(_dealers.map(dealer => {
        return {
          id: dealer.acf_dealers.dealerID,
          value: dealer.acf_dealers.dealerID,
          text: dealer.title,
        }
      }));

      const closest = _dealers[0];

      setDefaultDealer({
        id: closest?.acf_dealers.dealerID,
        value: closest?.acf_dealers.dealerID,
        text: closest?.title,
      });
      
      setDealerSummary(closest);

      return

    }

    // end

    const closestDealer = getClosestDealer(postcode, dealers, countryCode);

    const closestDealers = closestDealer ? [closestDealer] : getClosestDealersByPostcode(postcode, dealers, 3);

    const getDealer = () => {
      const dealerJson = localStorage.getItem('dealer');
      return dealerJson ? JSON.parse(dealerJson): null;
    }

    const lsDealer = getDealer();

    const savedDealerFromList = lsDealer ? dealers.find(item => {
      return item.title.toLowerCase() === lsDealer.title.toLowerCase();
    }) : null

    const tempDealerArr = savedDealerFromList ? [savedDealerFromList] : []

    setClosestDealers([...tempDealerArr, ...closestDealers])

    setDealersSelect([...tempDealerArr, ...closestDealers].map(dealer => {
      return {
        id: dealer.acf_dealers.dealerID,
        value: dealer.acf_dealers.dealerID,
        text: dealer.title,
      }
    }));

    // Set default
    const closest = savedDealerFromList ? savedDealerFromList : closestDealers[0];
    
    setDefaultDealer({
      id: closest.acf_dealers.dealerID,
      value: closest.acf_dealers.dealerID,
      text: closest.title,
    });
    setDealerSummary(closest)
  }

  const handleDealerUpdate = (select) => {
    if (!select) {
      return;
    }
    const seletedDealer = closestDealersState.find(item => {
      return item.title === select.text
    })
    setDealerSummary(seletedDealer);
    onFormChange();
  }
  
  return (
    <>
        <FormItem>
          <Controller
            {...textFieldProps}
            type="tel"
            rules={{
              ...textFieldProps.rules,
              type: 'custom',
              minLength: 3,
              maxLength: 4,
              validate: (val) => isPostalCode(val, 'AU')
            }}
            name={'postcode'}
            placeholder={'Postcode*'}
            error={get(errors, `[postcode]`, false) ? true : false}
            defaultValue={state.postcode || ''}
          />
          {get(errors, `[postcode]`, false) && <Error>Please add a 4 digit postcode</Error>}
        </FormItem>

        <FormItem display={dealersSelect.length > 0 ? 1 : 0}>
          <Controller
            as={
              <Dropdown 
                variant="outlined"
                showComplete={true}
                error={get(errors, `[dealer]`, false) ? true : false}
                label={null}
                options={dealersSelect}
              />
            }
            control={control}
            rules={{
              ...textFieldProps.rules,
              type: 'custom'
            }}
            defaultValue={typeof(state.dealer) === 'object' ? get(state, 'dealer.value', undefined) : state.dealer || undefined}
            name='dealer'
            onUpdate={handleDealerUpdate}
          />
        </FormItem>
    </>
  )
}

Step2.propTypes = {
  setDealerSummary: propTypes.func,
  countryCode: propTypes.string.isRequired
}

export default Step2